import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    width: '100%',
    height: '100%',
    overflow: 'auto',

    paddingBottom: '8rem',
});

export const errorAlert: TRuleWithTheme = ({ theme }) => ({
    '&.ant-alert': {
        marginBottom: 0,
        textAlign: 'center',
    },
});
